module.exports = __webpack_public_path__ + "static/media/Women.46ac9734.png";